<img src="../../../../assets/images/SPACE AR small.png" style="width:100px;margin-left:20px;"/>


<div style="margin-top:10px;"><span style="margin-left:20px;font-size:18px;font-weight: bold;;">Update LPR Status</span></div>
<div>

    <div style="margin-top:20px;margin-left:20px;margin-bottom:15px;margin-right:10px;">
       <p>Updating the LPR status will update all existing parkers in Amano ONE, which could take hours depending on the amount of parkers. </p>
        <p>If update requires for information to update ASAP, please choose Submit Now, otherwise click Schedule Later and the sync will occur overnight.</p>
    </div>
    
</div>
<!-- <img src="../../../../assets/icons/yellow-warning-triangle.png" style="height:30px;width:30px;margin-left:15px;top:40px;position:relative;"> -->
<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false" >Cancel</button>
  <button mat-button [mat-dialog-close]="'now'" cdkFocusInitial style="background-color:#003087 !important;color:white !important">Submit Now</button>
  <button mat-button [mat-dialog-close]="'schedule'" cdkFocusInitial style="background-color:#003087 !important;color:white !important">Schedule Later</button>
</div>
